export * from './mitarbeiter-post-request.interface';
export * from './mitarbeiter-post-response.interface';
export * from './mitarbeiter-post.shapes';
